module.exports = __webpack_public_path__ + "static/media/verify.bee52d4a.svg";